import React from 'react';
import { createRoot } from 'react-dom/client'; // Import createRoot from react-dom/client
import App from './App';

<title>Contractor Licensing Services - Test Prep App</title>;

const container = document.getElementById('root');
const root = createRoot(container); // Create a root
root.render(<App />); // Render your app
